<div class="manage-relatives-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-content">
      <h1>Manage Relatives</h1>
      <p>Add, edit, delete, and view family members in your network</p>
    </div>
    <div class="header-actions">
      <button class="btn-primary" (click)="openAddRelativeModal()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
          <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2"/>
        </svg>
        Add Relative
      </button>
    </div>
  </div>

  <!-- Search and Filter Section -->
  <div class="search-section">
    <div class="search-box">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
        <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2"/>
      </svg>
      <input 
        type="text" 
        placeholder="Search relatives by name, email, or referral code..." 
        [(ngModel)]="searchTerm" 
        (input)="filterRelatives()"
        class="search-input">
    </div>
    <div class="filter-actions">
      <button class="btn-secondary" (click)="loadRelatives()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <polyline points="23,4 23,10 17,10" stroke="currentColor" stroke-width="2"/>
          <polyline points="1,20 1,14 7,14" stroke="currentColor" stroke-width="2"/>
          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" stroke="currentColor" stroke-width="2"/>
        </svg>
        Refresh
      </button>
    </div>
  </div>

  <!-- Relatives Table -->
  <div class="table-container">
    <div class="table-responsive" *ngIf="filteredRelatives && filteredRelatives.length > 0">
      <table class="relatives-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Gender</th>
            <th>Date of Birth</th>
            <th>Status</th>
            <th>Referral Code</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let relative of filteredRelatives">
            <td>
              <div class="relative-name">
                <strong>{{ relative.firstName }} {{ relative.lastName }}</strong>
                <span *ngIf="relative.isDeceased" class="status-badge deceased">Deceased</span>
              </div>
            </td>
            <td>{{ relative.email }}</td>
            <td>{{ relative.mobileNumber }}</td>
            <td>{{ relative.gender }}</td>
            <td>{{ formatDate(relative.dateOfBirth) }}</td>
            <td>
              <span class="status-badge" [class.active]="relative.isActive" [class.inactive]="!relative.isActive">
                {{ relative.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>
              <div class="referral-info">
                <code>{{ relative.referralCode }}</code>
                <small *ngIf="relative.parentReferralCode" class="parent-ref">
                  Parent: {{ relative.parentReferralCode }}
                </small>
              </div>
            </td>
            <td>{{ formatDate(relative.createdAt) }}</td>
            <td>
              <div class="action-buttons">
                <button class="btn-icon" (click)="viewHierarchy(relative.id)" title="View Hierarchy">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
                <button class="btn-icon" (click)="editRelative(relative)" title="Edit">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 4H4A2 2 0 0 0 2 6V20A2 2 0 0 0 4 22H18A2 2 0 0 0 20 20V13" stroke="currentColor" stroke-width="2"/>
                    <path d="M18.5 2.5A2.121 2.121 0 0 1 21 5L12 14L8 15L9 11L18.5 2.5Z" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
                <button class="btn-icon" (click)="toggleRelativeStatus(relative.id)" [title]="relative.isActive ? 'Deactivate' : 'Activate'">
                  <svg *ngIf="relative.isActive" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18" stroke="currentColor" stroke-width="2"/>
                    <path d="M6 6L18 18" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <svg *ngIf="!relative.isActive" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 11.08V12A10 10 0 1 1 5.93 5.93" stroke="currentColor" stroke-width="2"/>
                    <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
                <button class="btn-icon danger" (click)="deleteRelative(relative.id)" title="Delete">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="3,6 5,6 21,6" stroke="currentColor" stroke-width="2"/>
                    <path d="M19,6V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V6M8,6V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V6" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!filteredRelatives || filteredRelatives.length === 0" class="empty-state">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
        <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2"/>
        <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2"/>
      </svg>
      <h3>No relatives found</h3>
      <p *ngIf="searchTerm">No relatives match your search criteria. Try adjusting your search terms.</p>
      <p *ngIf="!searchTerm">Start by adding your first family member.</p>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-container" *ngIf="relativesData && relativesData.totalPages > 1">
    <div class="pagination-info">
      <p>
        Showing {{ (relativesData.page - 1) * relativesData.pageSize + 1 }} to 
        {{ Math.min(relativesData.page * relativesData.pageSize, relativesData.totalCount) }} 
        of {{ relativesData.totalCount }} entries
      </p>
    </div>
    <div class="pagination-controls">
      <button 
        class="btn-pagination" 
        [disabled]="relativesData.page <= 1"
        (click)="loadRelatives(relativesData.page - 1)">
        Previous
      </button>
      <span class="page-info">Page {{ relativesData.page }} of {{ relativesData.totalPages }}</span>
      <button 
        class="btn-pagination" 
        [disabled]="relativesData.page >= relativesData.totalPages"
        (click)="loadRelatives(relativesData.page + 1)">
        Next
      </button>
    </div>
  </div>
</div>

<!-- Add/Edit Relative Modal -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-title">
        <div class="title-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 21V19A4 4 0 0 0 12 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
            <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
            <path d="M20 8V14" stroke="currentColor" stroke-width="2"/>
            <path d="M17 11L20 8L23 11" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <div class="title-text">
          <h2>{{ isEditing ? 'Edit Relative' : 'Add New Relative' }}</h2>
          <p>{{ isEditing ? 'Update relative information' : 'Add a new family member to your network' }}</p>
        </div>
      </div>
      <button class="modal-close" (click)="closeModal()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
          <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
        </svg>
      </button>
    </div>
    
    <form [formGroup]="relativeForm" (ngSubmit)="saveRelative()" class="modal-form">
      <!-- Personal Information Section -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 21V19A4 4 0 0 0 16 15H8A4 4 0 0 0 4 19V21" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3>Personal Information</h3>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="firstName">First Name *</label>
            <input 
              type="text" 
              id="firstName"
              formControlName="firstName" 
              class="form-input"
              placeholder="Enter first name"
              (input)="onNameChange()">
            <div class="field-error" *ngIf="relativeForm.get('firstName')?.invalid && relativeForm.get('firstName')?.touched">
              First name is required (minimum 2 characters)
            </div>
          </div>
          <div class="form-group">
            <label for="middleName">Middle Name</label>
            <input 
              type="text" 
              id="middleName"
              formControlName="middleName" 
              class="form-input"
              placeholder="Enter middle name (optional)">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="lastName">Last Name *</label>
            <input 
              type="text" 
              id="lastName"
              formControlName="lastName" 
              class="form-input"
              placeholder="Enter last name"
              (input)="onNameChange()">
            <div class="field-error" *ngIf="relativeForm.get('lastName')?.invalid && relativeForm.get('lastName')?.touched">
              Last name is required (minimum 2 characters)
            </div>
          </div>
          <div class="form-group">
            <label for="email">Email Address</label>
            <input 
              type="email" 
              id="email"
              formControlName="email" 
              class="form-input"
              placeholder="Enter email address"
              (input)="onNameChange()">
            <div class="field-error" *ngIf="relativeForm.get('email')?.invalid && relativeForm.get('email')?.touched">
              Please enter a valid email address
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="mobileNumber">Mobile Number *</label>
            <input 
              type="tel" 
              id="mobileNumber"
              formControlName="mobileNumber" 
              class="form-input"
              placeholder="Enter mobile number">
            <div class="field-error" *ngIf="relativeForm.get('mobileNumber')?.invalid && relativeForm.get('mobileNumber')?.touched">
              Please enter a valid mobile number
            </div>
          </div>
          <div class="form-group">
            <label for="dateOfBirth">Date of Birth *</label>
            <input 
              type="date" 
              id="dateOfBirth"
              formControlName="dateOfBirth" 
              class="form-input">
            <div class="field-error" *ngIf="relativeForm.get('dateOfBirth')?.invalid && relativeForm.get('dateOfBirth')?.touched">
              Date of birth is required
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="gender">Gender *</label>
            <select id="gender" formControlName="gender" class="form-input">
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
            <div class="field-error" *ngIf="relativeForm.get('gender')?.invalid && relativeForm.get('gender')?.touched">
              Please select a gender
            </div>
          </div>
          <div class="form-group">
            <label for="maritalStatus">Marital Status</label>
            <select id="maritalStatus" formControlName="maritalStatus" class="form-input">
              <option value="">Select Marital Status (Optional)</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
              <option value="Separated">Separated</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label for="isDeceased">Status</label>
            <div class="checkbox-container">
              <label class="checkbox-label">
                <input type="checkbox" formControlName="isDeceased" class="checkbox-input" id="isDeceased">
                <span class="checkbox-text">Deceased</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Profile Picture Section -->
      <div class="form-section" *ngIf="isEditing">
        <div class="section-header">
          <div class="section-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 21V19A4 4 0 0 0 16 15H8A4 4 0 0 0 4 19V21" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3>Profile Picture</h3>
        </div>
        
        <div class="avatar-section">
          <div class="avatar" [style.background-image]="avatarPreviewUrl ? 'url(' + avatarPreviewUrl + ')' : 'none'">
            <span *ngIf="!avatarPreviewUrl">{{ (relativeForm.get('firstName')?.value || 'U').slice(0,1) }}</span>
          </div>
          <label class="upload-btn">
            <input type="file" accept="image/*" (change)="onAvatarSelected($event)" />
            {{ avatarUploading ? 'Uploading...' : 'Change Photo' }}
          </label>
        </div>
      </div>

      <!-- Professional Information Section -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
              <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" stroke-width="2"/>
              <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3>Professional Information</h3>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="qualification">Qualification</label>
            <input 
              type="text" 
              id="qualification"
              formControlName="qualification" 
              class="form-input"
              placeholder="Enter qualification (optional)">
          </div>
          <div class="form-group">
            <label for="profession">Profession</label>
            <input 
              type="text" 
              id="profession"
              formControlName="profession" 
              class="form-input"
              placeholder="Enter profession (optional)">
          </div>
          <div class="form-group">
            <label for="location">Location</label>
            <input 
              type="text" 
              id="location"
              formControlName="location" 
              class="form-input"
              placeholder="Enter location (optional)">
          </div>
        </div>
      </div>

      <!-- Family Information Section -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3>Family Information</h3>
        </div>
        
        <!-- Relative's Referral Code (Admin only) -->
        <div class="form-row" *ngIf="isEditing">
          <div class="form-group">
            <label for="referralCode">Relative's Referral Code</label>
            <input 
              type="text" 
              id="referralCode"
              formControlName="referralCode" 
              class="form-input"
              placeholder="Enter referral code (6-12 characters, letters and numbers only)"
              maxlength="12">
            <div class="field-help">
              <small>🔧 Admin: Update the relative's referral code. Must be 6-12 characters, letters and numbers only.</small>
            </div>
            <div class="field-error" *ngIf="relativeForm.get('referralCode')?.invalid && relativeForm.get('referralCode')?.touched">
              Referral code must be 6-12 characters, letters and numbers only
            </div>
          </div>
        </div>
        
        <!-- Parent/Child Referrer Code (optional) -->
        <div class="form-row">
          <div class="form-group">
            <label for="parentReferralCode">Parent/Child Referrer Code</label>
            <input 
              type="text" 
              id="parentReferralCode"
              formControlName="parentReferralCode" 
              class="form-input"
              placeholder="Enter parent/child referrer's code (optional)">
            <div class="field-help">
              <small>💡 If you provide a parent/child referral code, this person will be a child of the referrer. You can also provide a spouse referral code if this person is married.</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Spouse Assignment Section -->
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
              <circle cx="16" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
              <path d="M11 11L13 13" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3>Spouse</h3>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label for="spouseReferralCode">Spouse Referral Code</label>
            <input 
              type="text" 
              id="spouseReferralCode"
              formControlName="spouseReferralCode" 
              class="form-input"
              placeholder="Enter spouse's referral code (must already be registered)">
            <div class="field-help">
              <small>💡 If you provide a spouse referral code, this person will be married to the referrer. You can provide both parent and spouse referral codes if the person is both a child and married.</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Account Credentials Section -->
      <div class="form-section credentials-section">
        <div class="section-header">
          <div class="section-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
              <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3>Account Credentials</h3>
          <p class="section-description">These credentials will be used for the relative's account access</p>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="username">Username *</label>
            <input 
              type="text" 
              id="username"
              formControlName="username" 
              class="form-input"
              placeholder="Auto-generated username">
            <div class="field-error" *ngIf="relativeForm.get('username')?.invalid && relativeForm.get('username')?.touched">
              Username is required (minimum 3 characters)
            </div>
          </div>
          <div class="form-group">
            <label for="password">{{ isEditing ? 'Password (current password shown)' : 'Password *' }}</label>
            <div class="password-input-group">
              <input 
                [type]="showPassword ? 'text' : 'password'" 
                id="password"
                formControlName="password" 
                class="form-input"
                [placeholder]="isEditing ? 'Current password is shown above' : 'Auto-generated password'">
              <div class="password-actions">
                <button type="button" class="btn-view-password" (click)="togglePasswordVisibility()" title="Toggle Password Visibility">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="!showPassword">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="showPassword">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20C5 20 1 12 1 12A18.45 18.45 0 0 1 5.06 5.06L17.94 17.94Z" stroke="currentColor" stroke-width="2"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4C19 4 23 12 23 12A18.5 18.5 0 0 1 19.76 14.1L9.9 4.24Z" stroke="currentColor" stroke-width="2"/>
                    <path d="M1 1L23 23" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
                <button type="button" class="btn-regenerate" (click)="regenerateCredentials()" title="Regenerate Password" *ngIf="!isEditing">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 4V10H7" stroke="currentColor" stroke-width="2"/>
                    <path d="M23 20V14H17" stroke="currentColor" stroke-width="2"/>
                    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="field-error" *ngIf="relativeForm.get('password')?.invalid && relativeForm.get('password')?.touched">
              Password must be at least 6 characters long
            </div>
            <div class="field-hint" *ngIf="!isEditing">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M12 16V12" stroke="currentColor" stroke-width="2"/>
                <path d="M12 8H12.01" stroke="currentColor" stroke-width="2"/>
              </svg>
              Credentials are auto-generated based on name and email
            </div>
            <div class="field-hint" *ngIf="isEditing && authService.isAdmin()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M12 16V12" stroke="currentColor" stroke-width="2"/>
                <path d="M12 8H12.01" stroke="currentColor" stroke-width="2"/>
              </svg>
              Admin view: Click the eye icon to view the actual password. Enter a new password to change it, or leave as is to keep current password.
            </div>
            <div class="field-hint" *ngIf="isEditing && !authService.isAdmin()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M12 16V12" stroke="currentColor" stroke-width="2"/>
                <path d="M12 8H12.01" stroke="currentColor" stroke-width="2"/>
              </svg>
              Current password is displayed above (masked for security). Enter a new password to change it, or leave as is to keep current password.
            </div>
            <div class="field-hint security-hint" *ngIf="isEditing && showPassword && isPasswordMasked && !authService.isAdmin()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2"/>
                <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2"/>
              </svg>
              For security reasons, the actual password cannot be displayed. The masked characters indicate a password exists.
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <div class="actions-left">
          <button type="button" class="btn-secondary" (click)="closeModal()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
            </svg>
            Cancel
          </button>
          <button type="button" class="btn-debug" (click)="debugForm()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <path d="M12 16V12" stroke="currentColor" stroke-width="2"/>
              <path d="M12 8H12.01" stroke="currentColor" stroke-width="2"/>
            </svg>
            Debug
          </button>
        </div>
        <div class="actions-right">
          <button type="submit" class="btn-primary" [disabled]="relativeForm.invalid || isLoading">
            <svg *ngIf="!isLoading" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H16L21 8V19A2 2 0 0 1 19 21Z" stroke="currentColor" stroke-width="2"/>
              <polyline points="17,21 17,13 7,13 7,21" stroke="currentColor" stroke-width="2"/>
              <polyline points="7,3 7,8 15,8" stroke="currentColor" stroke-width="2"/>
            </svg>
            <svg *ngIf="isLoading" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
                <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
              </circle>
            </svg>
            <span *ngIf="isLoading">Saving...</span>
            <span *ngIf="!isLoading">{{ isEditing ? 'Update Relative' : 'Add Relative' }}</span>
          </button>
        </div>
      </div>
    </form>

    <!-- Referral Links Section (Only shown when editing, at the end of the modal) -->
    <div class="referral-links-container" *ngIf="isEditing" style="margin-top: 2rem; border-top: 2px solid #e2e8f0; padding-top: 2rem; padding-left: 2rem; padding-right: 2rem; padding-bottom: 2rem;">
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="2"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3>Referral Links</h3>
          <p class="section-description">Share these links to invite family members to join</p>
        </div>

        <!-- Parent Referral Link -->
        <div class="referral-link-card">
          <div class="referral-link-header">
            <div class="referral-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <h4>For Children</h4>
          </div>
          <p class="referral-link-description">Share this link to add children to this relative's family tree</p>
          <div class="referral-link-input-group">
            <input 
              type="text" 
              [value]="parentReferralLink" 
              readonly 
              class="referral-link-input"
              [class.disabled]="!parentReferralLink"
              placeholder="Not available" />
            <div class="referral-link-actions">
              <button 
                type="button" 
                class="copy-btn"
                (click)="copyToClipboard(parentReferralLink, 'Parent')"
                [disabled]="!parentReferralLink"
                title="Copy link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M5 15H4A2 2 0 0 1 2 13V4A2 2 0 0 1 4 2H13A2 2 0 0 1 15 4V5" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
              <button 
                type="button" 
                class="share-btn"
                (click)="shareLink('parent')"
                [disabled]="!parentReferralLink"
                title="Share link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="5" r="3" stroke="currentColor" stroke-width="2"/>
                  <circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  <circle cx="18" cy="19" r="3" stroke="currentColor" stroke-width="2"/>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" stroke="currentColor" stroke-width="2"/>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Spouse Referral Link -->
        <div class="referral-link-card">
          <div class="referral-link-header">
            <div class="referral-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
                <circle cx="16" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M11 11L13 13" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <h4>For Spouse</h4>
          </div>
          <p class="referral-link-description">Share this link to connect this relative's spouse to the family tree</p>
          <div class="referral-link-input-group">
            <input 
              type="text" 
              [value]="spouseReferralLink" 
              readonly 
              class="referral-link-input"
              [class.disabled]="!spouseReferralLink"
              placeholder="Not available" />
            <div class="referral-link-actions">
              <button 
                type="button" 
                class="copy-btn"
                (click)="copyToClipboard(spouseReferralLink, 'Spouse')"
                [disabled]="!spouseReferralLink"
                title="Copy link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M5 15H4A2 2 0 0 1 2 13V4A2 2 0 0 1 4 2H13A2 2 0 0 1 15 4V5" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
              <button 
                type="button" 
                class="share-btn"
                (click)="shareLink('spouse')"
                [disabled]="!spouseReferralLink"
                title="Share link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="5" r="3" stroke="currentColor" stroke-width="2"/>
                  <circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  <circle cx="18" cy="19" r="3" stroke="currentColor" stroke-width="2"/>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" stroke="currentColor" stroke-width="2"/>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Sibling Referral Link -->
        <div class="referral-link-card">
          <div class="referral-link-header">
            <div class="referral-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M5 21V19A4 4 0 0 1 9 15H15A4 4 0 0 1 19 19V21" stroke="currentColor" stroke-width="2"/>
                <circle cx="8" cy="7" r="3" stroke="currentColor" stroke-width="2"/>
                <circle cx="16" cy="7" r="3" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <h4>For Siblings</h4>
          </div>
          <p class="referral-link-description" *ngIf="siblingReferralLink">
            Share this link to add siblings to the family tree (uses parent's referral code)
          </p>
          <p class="referral-link-description error" *ngIf="!siblingReferralLink">
            Sibling link is only available if this relative has a parent registered in the system
          </p>
          <div class="referral-link-input-group">
            <input 
              type="text" 
              [value]="siblingReferralLink" 
              readonly 
              class="referral-link-input"
              [class.disabled]="!siblingReferralLink"
              placeholder="Not available - no parent registered" />
            <div class="referral-link-actions">
              <button 
                type="button" 
                class="copy-btn"
                (click)="copyToClipboard(siblingReferralLink, 'Sibling')"
                [disabled]="!siblingReferralLink"
                title="Copy link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M5 15H4A2 2 0 0 1 2 13V4A2 2 0 0 1 4 2H13A2 2 0 0 1 15 4V5" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
              <button 
                type="button" 
                class="share-btn"
                (click)="shareLink('sibling')"
                [disabled]="!siblingReferralLink"
                title="Share link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="5" r="3" stroke="currentColor" stroke-width="2"/>
                  <circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  <circle cx="18" cy="19" r="3" stroke="currentColor" stroke-width="2"/>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" stroke="currentColor" stroke-width="2"/>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
